/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfReportParam } from '../models/data-page-of-report-param';
import { Globalattributes } from '../models/globalattributes';
import { ReportParam } from '../models/report-param';
import { reportParamDelete } from '../fn/report-param/report-param-delete';
import { ReportParamDelete$Params } from '../fn/report-param/report-param-delete';
import { reportParamGet } from '../fn/report-param/report-param-get';
import { ReportParamGet$Params } from '../fn/report-param/report-param-get';
import { reportParamGetglobalattributes } from '../fn/report-param/report-param-getglobalattributes';
import { ReportParamGetglobalattributes$Params } from '../fn/report-param/report-param-getglobalattributes';
import { reportParamGetRecord } from '../fn/report-param/report-param-get-record';
import { ReportParamGetRecord$Params } from '../fn/report-param/report-param-get-record';
import { reportParamPost } from '../fn/report-param/report-param-post';
import { ReportParamPost$Params } from '../fn/report-param/report-param-post';
import { reportParamPut } from '../fn/report-param/report-param-put';
import { ReportParamPut$Params } from '../fn/report-param/report-param-put';
import { reportParamUpdateRowSequence } from '../fn/report-param/report-param-update-row-sequence';
import { ReportParamUpdateRowSequence$Params } from '../fn/report-param/report-param-update-row-sequence';

@Injectable({ providedIn: 'root' })
export class ReportParamService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportParamGet()` */
  static readonly ReportParamGetPath = '/api/ReportParam/reportparam/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGet$Response(params?: ReportParamGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportParam>> {
    return reportParamGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGet(params?: ReportParamGet$Params, context?: HttpContext): Observable<DataPageOfReportParam> {
    return this.reportParamGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfReportParam>): DataPageOfReportParam => r.body)
    );
  }

  /** Path part for operation `reportParamGetRecord()` */
  static readonly ReportParamGetRecordPath = '/api/ReportParam/reportparam/singlerecord';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamGetRecord()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGetRecord$Response(params?: ReportParamGetRecord$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParam>> {
    return reportParamGetRecord(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamGetRecord$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGetRecord(params?: ReportParamGetRecord$Params, context?: HttpContext): Observable<ReportParam> {
    return this.reportParamGetRecord$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportParam>): ReportParam => r.body)
    );
  }

  /** Path part for operation `reportParamGetglobalattributes()` */
  static readonly ReportParamGetglobalattributesPath = '/api/ReportParam/reportparm/getglobalattributes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamGetglobalattributes()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGetglobalattributes$Response(params?: ReportParamGetglobalattributes$Params, context?: HttpContext): Observable<StrictHttpResponse<Globalattributes>> {
    return reportParamGetglobalattributes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamGetglobalattributes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamGetglobalattributes(params?: ReportParamGetglobalattributes$Params, context?: HttpContext): Observable<Globalattributes> {
    return this.reportParamGetglobalattributes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Globalattributes>): Globalattributes => r.body)
    );
  }

  /** Path part for operation `reportParamPost()` */
  static readonly ReportParamPostPath = '/api/ReportParam/reportparm/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportParamPost$Response(params: ReportParamPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportParamPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportParamPost(params: ReportParamPost$Params, context?: HttpContext): Observable<Blob> {
    return this.reportParamPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportParamPut()` */
  static readonly ReportParamPutPath = '/api/ReportParam/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportParamPut$Response(params: ReportParamPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParam>> {
    return reportParamPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportParamPut(params: ReportParamPut$Params, context?: HttpContext): Observable<ReportParam> {
    return this.reportParamPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportParam>): ReportParam => r.body)
    );
  }

  /** Path part for operation `reportParamDelete()` */
  static readonly ReportParamDeletePath = '/api/ReportParam/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamDelete$Response(params: ReportParamDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportParamDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamDelete(params: ReportParamDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.reportParamDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportParamUpdateRowSequence()` */
  static readonly ReportParamUpdateRowSequencePath = '/reportsparam/UpdateRowSequence';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportParamUpdateRowSequence()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamUpdateRowSequence$Response(params?: ReportParamUpdateRowSequence$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return reportParamUpdateRowSequence(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportParamUpdateRowSequence$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportParamUpdateRowSequence(params?: ReportParamUpdateRowSequence$Params, context?: HttpContext): Observable<void> {
    return this.reportParamUpdateRowSequence$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
